'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function BusComponent($filter, $http, AppConstants) {
	'ngInject';

	var service = {
		fetchBuses: fetchBuses,
		fetchBusesByDate: fetchBusesByDate,
		fetchWaibillByDate: fetchWaibillByDate,
		fetchBus: fetchBus,
		fetchWaybill: fetchWaybill,
		fetchAgreedSeats: fetchAgreedSeats,
		getBuses: getBuses,
		getBus: getBus,
		getAgreedSeats: getAgreedSeats,
		createBus: createBus,
		createAgreedSeats: createAgreedSeats,
		updateBus: updateBus,
		updateWaybill: updateWaybill,
		deleteBus: deleteBus,
		clearBuses: clearBuses
	};

	var buses = [];
	var bus = {};
	var agreedSeats = [];

	return service;

	/** */
	function createAgreedSeats(busId, seats) {
		var params = {
			'agreed_seats': seats,
			'bus_id': busId
		};

		return $http.post(AppConstants.apiUrl + '/agreed-seats', params).then(function () {})['catch'](function (err) {
			console.log(err);
		});
	}

	function fetchAgreedSeats(searchParams) {
		return $http.get(AppConstants.apiUrl + '/agreed-seats', {
			'params': {
				bus_id: searchParams.bus_id
			}
		}).then(setAgreedSeats)['catch'](failedRequest);
	}

	function fetchBuses(lineId) {
		var sort = arguments.length <= 1 || arguments[1] === undefined ? '-id' : arguments[1];
		var limit = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];

		return $http.get(AppConstants.apiUrl + '/buses', {
			'params': {
				sort: sort,
				limit: limit,
				'line_id': lineId,
				'with': 'stations,days,line'
			}
		}).then(setBuses)['catch'](failedRequest);
	}

	function fetchBusesByDate(date) {
		var sort = arguments.length <= 1 || arguments[1] === undefined ? '-id' : arguments[1];

		return $http.get(AppConstants.apiUrl + '/buses', {
			'params': {
				sort: sort,
				'departs_at': date,
				'with': 'stations,line'
			}
		}).then(setBuses)['catch'](failedRequest);
	}

	function fetchWaibillByDate(date) {
		var sort = arguments.length <= 1 || arguments[1] === undefined ? '-id' : arguments[1];

		return $http.get(AppConstants.apiUrl + '/waybills', {
			'params': {
				sort: sort,
				'departs_at': date,
				'with': 'stations,line'
			}
		}).then(setBuses)['catch'](failedRequest);
	}

	function fetchBus(id, date) {
		var relations = arguments.length <= 2 || arguments[2] === undefined ? 'translations,country' : arguments[2];

		return $http.get(AppConstants.apiUrl + '/buses/' + id, {
			'params': {
				date: date,
				'with': relations
			},
			'config': {
				headers: {
					'Accept-Language': 'en'
				}
			}
		}).then(setBus)['catch'](failedRequest);
	}

	function fetchWaybill(busId, date) {
		return $http.get(AppConstants.apiUrl + '/waybills/' + busId, {
			'params': {
				date: date,
				'sort': 'number'
			}
		}).then(successRequest)['catch'](failedRequest);
	}

	function setBuses(response) {
		buses = response.data.data;

		return buses;
	}

	function setBus(response) {
		if (response.data && response.data.errors) {
			bus = response;
		} else {
			bus = response.data.data;
		}

		return bus;
	}

	function getBuses() {
		return buses;
	}

	function getBus() {
		return bus;
	}

	function createBus(params) {
		return $http.post(AppConstants.apiUrl + '/buses', params).then(successRequest)['catch'](failedRequest);
	}

	function updateBus(id, params) {
		return $http.put(AppConstants.apiUrl + '/buses/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteBus(id) {
		return $http['delete'](AppConstants.apiUrl + '/buses/' + id).then(successRequest)['catch'](failedRequest);
	}

	function updateWaybill(id, params) {
		return $http.put(AppConstants.apiUrl + '/waybills/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);

		return requestError;
	}

	function clearBuses() {
		buses = [];
	}

	function getAgreedSeats() {
		return agreedSeats;
	}

	function setAgreedSeats(response) {
		agreedSeats = response.data.data;

		return agreedSeats;
	}
}
exports['default'] = BusComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/bus/bus.service.js
 **/